
import { Component, Prop, Vue } from 'vue-property-decorator';
import GetHelpScanning from "@/components/steps/submit/helpPages/GetHelpScanning.vue";

import { documentTypesJsonInfoType } from '@/types/Common';

@Component({
    components:{
        GetHelpScanning
    }
})
export default class OtherRequiredFormsList extends Vue {    

    @Prop({required: true})
    requiredDocumentLists!: documentTypesJsonInfoType[];   

    @Prop({required: true})
    eFiling!: boolean;   

    showGetHelpScanning = false;
   
}
